import { styled, spacing, Text } from '@thg-commerce/gravity-theme'

import { HorizontalAlignment } from '../ProductBlock/types'

export const Title = styled.h3<{
  useAlternateTitleStyle: boolean
  alignment?: HorizontalAlignment
}>`
  word-break: break-word;
  ${(props) =>
    Text('bodyText', props.useAlternateTitleStyle ? 'alternate' : 'default')}
  ${(props) => props.alignment && `text-align:${props.alignment};`}

  margin-bottom: ${spacing(2)};
`
